// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBYpf0zVQ_5aU7loponrMz-_-4MzCzX6i4",
  authDomain: "thriwe-app-v2-9ae65.firebaseapp.com",
  projectId: "thriwe-app-v2-9ae65",
  storageBucket: "thriwe-app-v2-9ae65.appspot.com",
  messagingSenderId: "593132292989",
  appId: "1:593132292989:web:f1dd76364323c1096c9a14",
  measurementId: "G-CYLNPHZTGH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: "select_account",
  display: "popup",
  appName: "Thriwe App",
});
const appleProvider = new OAuthProvider("apple.com");
appleProvider.setCustomParameters({
  prompt: "select_account",
  display: "popup",
});
// const appleProvider =

const face_provider = new FacebookAuthProvider();
face_provider.setCustomParameters({
  prompt: "select_account",
  display: "popup",
});

// Initialize Firebase Auth
export const auth = getAuth();
const authapple = auth;
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
export const signInWithFacebookPopup = () =>
  signInWithPopup(auth, face_provider);
export const signInWithApple = () => signInWithPopup(auth, appleProvider);
// Conditionally initialize Firebase Analytics on the client-side
if (typeof window !== "undefined") {
  const analytics = getAnalytics(app);
}
